/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react'
import Layout from '../Home'
import { observer, inject } from 'mobx-react'
import FollowUpBookingTable from '../../components/FollowUpBookingTable'
import { message } from 'antd'
@inject('Appointment')
@inject('Booking')
@observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tableLoading: true,
      buttonLoading: {},
      followUpBookings: [],
      filterBookings: [],
    }
  }
  componentDidMount() {
    this.fetchFollowUpBooking()
  }

  fetchFollowUpBooking = async () => {
    this.setState({
      tableLoading: true,
    })
    const { Booking } = this.props
    const response = await Booking.fetchFollowUpBooking()
    this.setState({
      followUpBookings: response,
      filterBookings: [],
      tableLoading: false,
    })
  }

  fetchNextAppointment = async (bookingId) => {
    let buttonLoad = this.state.buttonLoading
    buttonLoad[bookingId] = true
    this.setState({
      buttonLoading: buttonLoad,
    })
    const { Appointment, Booking } = this.props
    const nextAppointmentData = await Appointment.getNextAppointment(bookingId)
    // Appointments/upcoming resolves an empty object when HIE has no match, and {} is
    // truthy — check the field itself or the row is left untouched behind a success toast.
    if (nextAppointmentData?.appointmentDateTime) {
      await Booking.updateBooking(bookingId, { nextAppointment: nextAppointmentData.appointmentDateTime })
      this.fetchFollowUpBooking()
      message.success('โหลดข้อมูลนัดหมายสำเร็จ')
    } else {
      message.error('ไม่พบข้อมูลนัดหมาย')
    }
    buttonLoad[bookingId] = false
    this.setState({
      buttonLoading: buttonLoad,
    })
  }

  handleUpdateBooking = async (bookingId) => {
    const { Booking } = this.props
    this.setState({
      tableLoading: true,
    })
    const response = await Booking.updateBooking(bookingId, { followUp: false })
    if (response) {
      message.success('เปลี่ยนสถานะการนัดหมายสำเร็จ')
      this.fetchFollowUpBooking()
    }
    this.setState({
      tableLoading: false,
    })
  }

  onSearch = (patientName = '') => {
    const filterByPatientName = this.state.followUpBookings.filter((item) => {
      // Patients with no HIE record carry an empty or null fullnameHIE, so both names
      // have to be coerced before includes() is called on them.
      const fullnameHIE = item.patient?.fullnameHIE || ''
      const fullname = item.patient?.fullname || ''
      return fullnameHIE.includes(patientName) || fullname.includes(patientName)
    })
    this.setState({
      filterBookings: filterByPatientName,
    })
  }

  render() {
    return (
      <Layout
        {...this.props}
        render={(
          props, //eslint-disable-line
        ) => (
          <div className="w-100">
            <FollowUpBookingTable
              followUpBookings={this.state.filterBookings.length ? this.state.filterBookings : this.state.followUpBookings}
              loading={this.state.tableLoading}
              buttonLoading={this.state.buttonLoading}
              onSearch={this.onSearch}
              fetchNextAppointment={this.fetchNextAppointment}
              handleUpdateBooking={this.handleUpdateBooking}
            />
          </div>
        )}
      />
    )
  }
}
